import React from 'react';

import { useGGTheme } from 'hooks/theme/useGGTheme';

export function PortfolioContainer() {
  const {
    components: { Layout },
    pages: { Portfolio },
  } = useGGTheme();

  return (
    <Layout>
      <Portfolio />
    </Layout>
  );
}
